import type { ErrorMap } from '@/app/error-registry';

export const CALENDAR_DELETE_CONNECTION_ERROR_MAP: ErrorMap = {
  DELETE: {
    'CalendarConnection.NotFound': 'calendar:integrations.apiErrors.connectionNotFound',
    default: 'calendar:integrations.apiErrors.deleteDefault',
  },
};

export const CALENDAR_UPDATE_LINKED_CALENDAR_ERROR_MAP: ErrorMap = {
  PATCH: {
    'CalendarConnection.NotFound': 'calendar:integrations.apiErrors.connectionNotFound',
    'LinkedCalendar.NotFound': 'calendar:integrations.apiErrors.linkedCalendarNotFound',
    'LinkedCalendar.TenantScopeRequiresTenantId':
      'calendar:integrations.apiErrors.tenantScopeRequiresTenantId',
    'LinkedCalendar.GlobalScopeForbidsTenantId':
      'calendar:integrations.apiErrors.globalScopeForbidsTenantId',
    'LinkedCalendar.TenantMembershipRequired':
      'calendar:integrations.apiErrors.tenantMembershipRequired',
    default: 'calendar:integrations.apiErrors.updateDefault',
  },
};

export const CALENDAR_AUTHORIZE_ERROR_MAP: ErrorMap = {
  GET: {
    'CalendarOAuth.UnsupportedProvider': 'calendar:integrations.apiErrors.unsupportedProvider',
    default: 'calendar:integrations.apiErrors.authorizeDefault',
  },
};

export const CALENDAR_SYNC_ERROR_MAP: ErrorMap = {
  POST: {
    'CalendarConnection.NotFound': 'calendar:integrations.apiErrors.connectionNotFound',
    'CalendarConnection.NotActive': 'calendar:integrations.apiErrors.connectionNotActive',
    'CalendarConnection.SyncIncomplete': 'calendar:integrations.apiErrors.syncIncomplete',
    default: 'calendar:integrations.apiErrors.syncDefault',
  },
};
